const businessManagementQuestions = [

{
  question: "A business expands rapidly but fails due to poor coordination among departments. This situation best reflects:",
  options: ["weak management structure", "lack of capital", "low demand", "external economic pressure"],
  answer: "weak management structure"
},
{
  question: "Which of the following best distinguishes a business from other economic activities?",
  options: ["continuous production of goods and services for profit", "occasional exchange of goods", "government regulation", "charitable activities"],
  answer: "continuous production of goods and services for profit"
},
{
  question: "A sole proprietor bears unlimited liability. This implies that:",
  options: ["personal assets may be used to settle business debts", "profits are shared equally", "business is controlled by shareholders", "liability is limited to capital invested"],
  answer: "personal assets may be used to settle business debts"
},
{
  question: "A major weakness of partnership as a form of business is:",
  options: ["joint liability among partners", "limited decision-making", "lack of capital always", "government interference"],
  answer: "joint liability among partners"
},
{
  question: "Which of the following businesses is most suitable for raising large capital?",
  options: ["public limited company", "sole proprietorship", "partnership", "co-operative"],
  answer: "public limited company"
},
{
  question: "A business responding to environmental pollution complaints is fulfilling its:",
  options: ["social responsibility", "economic objective", "legal duty only", "profit motive"],
  answer: "social responsibility"
},
{
  question: "Internal business environment includes:",
  options: ["management style and workforce", "government policies", "inflation rate", "technological change"],
  answer: "management style and workforce"
},
{
  question: "Which external factor is most unpredictable for business planning?",
  options: ["economic conditions", "employee behavior", "organizational structure", "internal finance"],
  answer: "economic conditions"
},
{
  question: "A company maximizing profit at the expense of employee welfare is ignoring:",
  options: ["ethical responsibility", "economic objective", "production efficiency", "market demand"],
  answer: "ethical responsibility"
},
{
  question: "Which stakeholder group is most concerned with dividends?",
  options: ["shareholders", "employees", "government", "customers"],
  answer: "shareholders"
},
{
  question: "A business fails due to poor decision-making and lack of planning. This is classified as:",
  options: ["managerial incompetence", "external risk", "financial limitation", "market failure"],
  answer: "managerial incompetence"
},
{
  question: "Which of the following best explains a co-operative society?",
  options: ["business owned and run by members for mutual benefit", "government-owned enterprise", "profit-maximizing company", "private limited firm"],
  answer: "business owned and run by members for mutual benefit"
},
{
  question: "The main objective of most private businesses is:",
  options: ["profit maximization", "social welfare", "employment creation only", "government policy compliance"],
  answer: "profit maximization"
},
{
  question: "Which form of business has the greatest continuity?",
  options: ["limited liability company", "sole proprietorship", "partnership", "informal sector"],
  answer: "limited liability company"
},
{
  question: "A business reacting to changes in technology is responding to:",
  options: ["external environment", "internal policy", "organizational structure", "financial planning"],
  answer: "external environment"
},
{
  question: "Which of the following best explains business growth failure despite high demand?",
  options: ["poor management decisions", "strong market conditions", "high customer loyalty", "increased production"],
  answer: "poor management decisions"
},
{
  question: "A partnership agreement mainly governs:",
  options: ["profit sharing and responsibilities", "government taxation", "employee wages", "customer relations"],
  answer: "profit sharing and responsibilities"
},
{
  question: "Which of the following best explains stakeholder conflict?",
  options: ["different interests among groups", "lack of employees", "low production", "absence of capital"],
  answer: "different interests among groups"
},
{
  question: "A business focusing on long-term survival rather than immediate profit is pursuing:",
  options: ["strategic objective", "operational goal", "short-term plan", "tactical decision"],
  answer: "strategic objective"
},
{
  question: "Which factor is most likely to cause sudden business failure?",
  options: ["poor risk management", "high sales", "efficient planning", "strong leadership"],
  answer: "poor risk management"
},

{
  question: "A manager sets long-term goals and determines overall direction of a company. This is best described as:",
  options: ["strategic planning", "operational planning", "delegation", "controlling"],
  answer: "strategic planning"
},
{
  question: "Which stage in planning involves comparing different possible actions before selecting one?",
  options: ["evaluation of alternatives", "implementation", "goal setting", "monitoring"],
  answer: "evaluation of alternatives"
},
{
  question: "A company develops backup plans in case its main strategy fails. This is known as:",
  options: ["contingency planning", "strategic planning", "operational control", "decision analysis"],
  answer: "contingency planning"
},
{
  question: "Which of the following best explains why planning is essential in management?",
  options: ["it reduces uncertainty and provides direction", "it eliminates risk completely", "it increases employee workload", "it replaces decision-making"],
  answer: "it reduces uncertainty and provides direction"
},
{
  question: "A decision made routinely based on established procedures is called:",
  options: ["programmed decision", "strategic decision", "tactical decision", "non-programmed decision"],
  answer: "programmed decision"
},
{
  question: "Non-programmed decisions are typically:",
  options: ["unique and require judgment", "routine and repetitive", "automatic responses", "based on fixed rules"],
  answer: "unique and require judgment"
},
{
  question: "Which level of management is mainly responsible for strategic decisions?",
  options: ["top management", "middle management", "lower management", "supervisory staff"],
  answer: "top management"
},
{
  question: "A manager gathers data, identifies alternatives and selects the best option. This process is:",
  options: ["decision-making", "planning", "organizing", "delegating"],
  answer: "decision-making"
},
{
  question: "Which of the following is NOT a step in decision-making?",
  options: ["ignoring alternatives", "identifying the problem", "evaluating options", "implementing decision"],
  answer: "ignoring alternatives"
},
{
  question: "A committee formed to make decisions on company policy is an example of:",
  options: ["group decision-making", "individual planning", "delegation", "control system"],
  answer: "group decision-making"
},
{
  question: "Which advantage is associated with group decision-making?",
  options: ["diverse ideas and better solutions", "faster decisions always", "less conflict", "reduced responsibility"],
  answer: "diverse ideas and better solutions"
},
{
  question: "A manager divides work into smaller tasks and assigns them to employees. This is:",
  options: ["organizing", "planning", "controlling", "directing"],
  answer: "organizing"
},
{
  question: "Which principle of organizing ensures that each employee reports to only one supervisor?",
  options: ["unity of command", "division of labour", "authority", "delegation"],
  answer: "unity of command"
},
{
  question: "An organizational structure that combines functional and project-based systems is called:",
  options: ["matrix structure", "line structure", "functional structure", "flat structure"],
  answer: "matrix structure"
},
{
  question: "Which of the following is a key advantage of division of labour?",
  options: ["increased efficiency and specialization", "reduced productivity", "higher costs", "limited skills"],
  answer: "increased efficiency and specialization"
},
{
  question: "A business expands and becomes difficult to manage due to complexity. This reflects:",
  options: ["organizational growth challenges", "effective planning", "strong leadership", "good coordination"],
  answer: "organizational growth challenges"
},
{
  question: "Centralization in an organization means:",
  options: ["decision-making authority is concentrated at the top", "authority is shared equally", "employees make all decisions", "no control system exists"],
  answer: "decision-making authority is concentrated at the top"
},
{
  question: "Decentralization improves management by:",
  options: ["allowing faster decision-making at lower levels", "eliminating authority", "reducing responsibility", "centralizing control"],
  answer: "allowing faster decision-making at lower levels"
},
{
  question: "Which of the following is a limitation of planning?",
  options: ["reliance on inaccurate data", "clear direction", "improved coordination", "goal achievement"],
  answer: "reliance on inaccurate data"
},
{
  question: "A manager uses budgets and schedules to guide operations. These are examples of:",
  options: ["planning tools", "control systems", "organizational structures", "decision models"],
  answer: "planning tools"
},

{
  question: "Delegation involves the transfer of:",
  options: ["authority with responsibility but not accountability", "responsibility and accountability only", "authority only without responsibility", "accountability without authority"],
  answer: "authority with responsibility but not accountability"
},
{
  question: "A manager assigns a task but retains final responsibility. This reflects:",
  options: ["delegation principle", "centralization", "span of control", "line authority"],
  answer: "delegation principle"
},
{
  question: "Which of the following is a major barrier to effective delegation?",
  options: ["lack of trust in subordinates", "clear communication", "employee competence", "defined authority"],
  answer: "lack of trust in subordinates"
},
{
  question: "Delegation improves organizational efficiency by:",
  options: ["reducing workload of top managers", "eliminating responsibility", "centralizing decisions", "increasing confusion"],
  answer: "reducing workload of top managers"
},
{
  question: "Which of the following best defines leadership?",
  options: ["ability to influence others towards goals", "authority to command employees", "control over resources", "ownership of business"],
  answer: "ability to influence others towards goals"
},
{
  question: "An autocratic leader typically:",
  options: ["makes decisions alone", "consults employees fully", "delegates all authority", "encourages independence always"],
  answer: "makes decisions alone"
},
{
  question: "Which leadership style is most suitable for highly skilled workers?",
  options: ["democratic leadership", "autocratic leadership", "laissez-faire leadership only", "bureaucratic leadership"],
  answer: "democratic leadership"
},
{
  question: "Laissez-faire leadership is characterized by:",
  options: ["minimal supervision and high employee freedom", "strict control", "centralized decisions", "rigid rules"],
  answer: "minimal supervision and high employee freedom"
},
{
  question: "A leader who inspires employees through vision and motivation demonstrates:",
  options: ["transformational leadership", "autocratic leadership", "transactional leadership", "bureaucratic leadership"],
  answer: "transformational leadership"
},
{
  question: "Which leadership style is most effective during crisis situations?",
  options: ["autocratic leadership", "democratic leadership", "laissez-faire leadership", "participative leadership"],
  answer: "autocratic leadership"
},
{
  question: "Motivation in management refers to:",
  options: ["stimulating employees to achieve goals", "increasing wages only", "reducing workload", "providing supervision"],
  answer: "stimulating employees to achieve goals"
},
{
  question: "According to Maslow, the highest level of need is:",
  options: ["self-actualization", "esteem", "social needs", "safety"],
  answer: "self-actualization"
},
{
  question: "Which need involves job security and protection?",
  options: ["safety needs", "physiological needs", "esteem needs", "social needs"],
  answer: "safety needs"
},
{
  question: "Providing bonuses and salaries addresses:",
  options: ["physiological needs", "esteem needs", "self-actualization", "social needs"],
  answer: "physiological needs"
},
{
  question: "Recognition and respect relate to:",
  options: ["esteem needs", "safety needs", "physiological needs", "social needs"],
  answer: "esteem needs"
},
{
  question: "Which of the following is a non-financial motivator?",
  options: ["promotion opportunities", "salary increase", "bonus payment", "commission"],
  answer: "promotion opportunities"
},
{
  question: "A company offering flexible working hours is improving:",
  options: ["employee motivation", "production cost", "market share", "profit margin"],
  answer: "employee motivation"
},
{
  question: "Which theory suggests workers are naturally lazy and need strict control?",
  options: ["Theory X", "Theory Y", "Maslow theory", "Herzberg theory"],
  answer: "Theory X"
},
{
  question: "Theory Y assumes employees:",
  options: ["are self-motivated and responsible", "avoid work", "require strict supervision", "lack initiative"],
  answer: "are self-motivated and responsible"
},
{
  question: "Which factor reduces employee motivation most?",
  options: ["lack of recognition", "high salary", "promotion", "job satisfaction"],
  answer: "lack of recognition"
},

{
  question: "Effective communication is best achieved when:",
  options: ["the message is clearly understood by the receiver", "the sender speaks fluently", "the channel is formal", "the receiver agrees with the sender"],
  answer: "the message is clearly understood by the receiver"
},
{
  question: "Which element of communication ensures feedback?",
  options: ["receiver response", "message encoding", "communication channel", "sender intention"],
  answer: "receiver response"
},
{
  question: "A breakdown in communication due to language differences is a:",
  options: ["semantic barrier", "physical barrier", "organizational barrier", "technological barrier"],
  answer: "semantic barrier"
},
{
  question: "Which communication channel is most suitable for urgent decisions?",
  options: ["face-to-face communication", "written memo", "email", "notice board"],
  answer: "face-to-face communication"
},
{
  question: "Downward communication in an organization refers to:",
  options: ["flow of information from management to employees", "communication among peers", "communication from employees to management", "external communication"],
  answer: "flow of information from management to employees"
},
{
  question: "Upward communication is important because it:",
  options: ["provides feedback to management", "enforces authority", "reduces employee involvement", "limits decision-making"],
  answer: "provides feedback to management"
},
{
  question: "Which of the following is an example of informal communication?",
  options: ["grapevine", "official report", "formal memo", "policy document"],
  answer: "grapevine"
},
{
  question: "The major disadvantage of informal communication is:",
  options: ["distortion of information", "speed of communication", "flexibility", "ease of use"],
  answer: "distortion of information"
},
{
  question: "Which of the following improves communication effectiveness?",
  options: ["clarity of message", "complex language", "long messages", "technical jargon"],
  answer: "clarity of message"
},
{
  question: "Noise in communication refers to:",
  options: ["any factor that distorts the message", "loud sound only", "external communication", "formal message"],
  answer: "any factor that distorts the message"
},
{
  question: "A manager using reports and performance indicators is practicing:",
  options: ["control function", "planning", "organizing", "delegation"],
  answer: "control function"
},
{
  question: "Control in management ensures:",
  options: ["actual performance meets planned objectives", "employees are punished", "communication is reduced", "authority is centralized"],
  answer: "actual performance meets planned objectives"
},
{
  question: "Which stage of control involves comparing performance with standards?",
  options: ["evaluation", "implementation", "planning", "delegation"],
  answer: "evaluation"
},
{
  question: "Setting performance standards is part of:",
  options: ["control process", "communication process", "planning process", "leadership process"],
  answer: "control process"
},
{
  question: "Corrective action in control means:",
  options: ["adjusting activities to meet standards", "punishing employees", "ignoring deviations", "increasing workload"],
  answer: "adjusting activities to meet standards"
},
{
  question: "Which of the following is a limitation of control systems?",
  options: ["high cost of implementation", "improved efficiency", "clear objectives", "better coordination"],
  answer: "high cost of implementation"
},
{
  question: "Feedback in communication is essential because it:",
  options: ["confirms understanding", "reduces message clarity", "limits communication", "increases barriers"],
  answer: "confirms understanding"
},
{
  question: "Which barrier arises from poor organizational structure?",
  options: ["organizational barrier", "semantic barrier", "physical barrier", "psychological barrier"],
  answer: "organizational barrier"
},
{
  question: "A manager ignoring feedback is likely to cause:",
  options: ["communication failure", "effective planning", "strong leadership", "better control"],
  answer: "communication failure"
},
{
  question: "Which of the following best explains effective control?",
  options: ["continuous monitoring and corrective action", "punishment of workers", "strict supervision only", "reducing employee involvement"],
  answer: "continuous monitoring and corrective action"
},

{
  question: "Information and Communication Technology (ICT) in business is mainly used to:",
  options: ["improve efficiency and communication", "replace all workers", "increase costs", "eliminate planning"],
  answer: "improve efficiency and communication"
},
{
  question: "A company using online platforms to sell goods directly to consumers is engaged in:",
  options: ["B2C e-commerce", "B2B e-commerce", "C2C e-commerce", "G2B e-commerce"],
  answer: "B2C e-commerce"
},
{
  question: "Which of the following best explains B2B e-commerce?",
  options: ["transactions between businesses", "sales to final consumers", "government transactions", "consumer-to-consumer sales"],
  answer: "transactions between businesses"
},
{
  question: "The use of ICT reduces business costs mainly by:",
  options: ["automating processes", "increasing labour", "reducing production", "limiting communication"],
  answer: "automating processes"
},
{
  question: "Which of the following is a disadvantage of e-commerce?",
  options: ["security risks and fraud", "fast transactions", "global reach", "low operational cost"],
  answer: "security risks and fraud"
},
{
  question: "Electronic payment systems are important because they:",
  options: ["facilitate quick transactions", "eliminate business risks", "increase physical cash usage", "reduce communication"],
  answer: "facilitate quick transactions"
},
{
  question: "Which ICT tool is most useful for internal communication in organizations?",
  options: ["intranet", "television", "radio", "newspaper"],
  answer: "intranet"
},
{
  question: "An extranet allows businesses to:",
  options: ["share information with external partners", "restrict access completely", "replace internet", "store data only"],
  answer: "share information with external partners"
},
{
  question: "Which of the following best explains cloud computing?",
  options: ["storing and accessing data over the internet", "saving files on local devices only", "offline communication", "manual data storage"],
  answer: "storing and accessing data over the internet"
},
{
  question: "A major advantage of cloud computing for businesses is:",
  options: ["remote access to data", "high hardware costs", "limited storage", "data isolation"],
  answer: "remote access to data"
},
{
  question: "Which of the following improves decision-making using ICT?",
  options: ["management information systems", "manual records", "paper files only", "traditional meetings"],
  answer: "management information systems"
},
{
  question: "Data security in ICT systems refers to:",
  options: ["protection of information from unauthorized access", "sharing all data freely", "increasing system access", "eliminating passwords"],
  answer: "protection of information from unauthorized access"
},
{
  question: "A business using social media for advertising is engaging in:",
  options: ["digital marketing", "direct selling", "traditional promotion", "production management"],
  answer: "digital marketing"
},
{
  question: "Which of the following is a challenge of ICT adoption in business?",
  options: ["high initial cost", "improved efficiency", "faster communication", "global access"],
  answer: "high initial cost"
},
{
  question: "Online marketplaces like e-commerce platforms provide:",
  options: ["access to wider markets", "limited customer base", "high physical costs", "restricted trade"],
  answer: "access to wider markets"
},
{
  question: "Automation in business leads to:",
  options: ["increased productivity", "reduced efficiency", "higher labour demand", "limited output"],
  answer: "increased productivity"
},
{
  question: "Which of the following best explains cybercrime?",
  options: ["illegal activities using computers", "manual fraud only", "legal online transactions", "government regulation"],
  answer: "illegal activities using computers"
},
{
  question: "A business storing customer data digitally must ensure:",
  options: ["data privacy compliance", "unrestricted access", "manual backup only", "no security measures"],
  answer: "data privacy compliance"
},
{
  question: "Which ICT system helps track inventory automatically?",
  options: ["database management system", "manual ledger", "telephone system", "fax machine"],
  answer: "database management system"
},
{
  question: "The main role of ICT in supply chain management is to:",
  options: ["improve coordination and tracking", "reduce communication", "increase delays", "limit information flow"],
  answer: "improve coordination and tracking"
},

{
  question: "A valid contract must include:",
  options: ["offer, acceptance, consideration, intention", "payment only", "written agreement only", "government approval"],
  answer: "offer, acceptance, consideration, intention"
},
{
  question: "An offer becomes legally binding when:",
  options: ["it is accepted", "it is proposed", "it is rejected", "it is withdrawn"],
  answer: "it is accepted"
},
{
  question: "Consideration in a contract refers to:",
  options: ["something of value exchanged", "verbal agreement", "written document", "legal enforcement"],
  answer: "something of value exchanged"
},
{
  question: "A contract without consideration is generally:",
  options: ["void", "valid", "binding", "legal"],
  answer: "void"
},
{
  question: "Which of the following contracts is unenforceable by law?",
  options: ["illegal contract", "valid contract", "express contract", "bilateral contract"],
  answer: "illegal contract"
},
{
  question: "A minor entering into a contract is considered:",
  options: ["not legally bound", "fully liable", "fully responsible", "legally competent"],
  answer: "not legally bound"
},
{
  question: "Which type of contract is formed through spoken words?",
  options: ["oral contract", "written contract", "implied contract", "void contract"],
  answer: "oral contract"
},
{
  question: "A breach of contract occurs when:",
  options: ["one party fails to fulfill obligations", "both parties agree", "contract is signed", "terms are clear"],
  answer: "one party fails to fulfill obligations"
},
{
  question: "Remedy for breach of contract includes:",
  options: ["damages", "punishment only", "imprisonment only", "dismissal only"],
  answer: "damages"
},
{
  question: "An agent acts on behalf of:",
  options: ["principal", "government", "employee", "customer"],
  answer: "principal"
},
{
  question: "Which of the following defines agency relationship?",
  options: ["one person acts for another in business transactions", "government controls business", "employee supervises manager", "business sells goods"],
  answer: "one person acts for another in business transactions"
},
{
  question: "Authority given explicitly to an agent is called:",
  options: ["express authority", "implied authority", "apparent authority", "legal authority"],
  answer: "express authority"
},
{
  question: "Implied authority arises from:",
  options: ["nature of the job", "written agreement only", "government law", "contract breach"],
  answer: "nature of the job"
},
{
  question: "Which type of authority is based on appearance or representation?",
  options: ["apparent authority", "express authority", "implied authority", "actual authority"],
  answer: "apparent authority"
},
{
  question: "An agent exceeding authority makes the principal:",
  options: ["not liable unless ratified", "always liable", "automatically guilty", "legally void"],
  answer: "not liable unless ratified"
},
{
  question: "Ratification occurs when:",
  options: ["principal approves agent’s unauthorized act", "agent cancels contract", "contract becomes void", "authority is removed"],
  answer: "principal approves agent’s unauthorized act"
},
{
  question: "Which of the following terminates agency?",
  options: ["death of either party", "increase in profit", "contract renewal", "business expansion"],
  answer: "death of either party"
},
{
  question: "A contract entered under misrepresentation is:",
  options: ["voidable", "valid", "illegal", "enforceable"],
  answer: "voidable"
},
{
  question: "A contract is void if:",
  options: ["it lacks essential elements", "it is written", "both parties agree", "it involves money"],
  answer: "it lacks essential elements"
},
{
  question: "Which of the following best explains legal capacity?",
  options: ["ability to enter into a contract", "ability to pay money", "authority to manage business", "ability to supervise workers"],
  answer: "ability to enter into a contract"
},

{
  question: "The primary objective of financial management is to:",
  options: ["maximize shareholder wealth", "increase production only", "reduce employees", "increase expenses"],
  answer: "maximize shareholder wealth"
},
{
  question: "Which source of finance is most suitable for long-term expansion?",
  options: ["equity capital", "bank overdraft", "trade credit", "cash sales"],
  answer: "equity capital"
},
{
  question: "A bank overdraft is classified as:",
  options: ["short-term finance", "long-term finance", "internal finance", "equity finance"],
  answer: "short-term finance"
},
{
  question: "Retained earnings are considered:",
  options: ["internal source of finance", "external borrowing", "short-term liability", "fixed cost"],
  answer: "internal source of finance"
},
{
  question: "Which of the following is a disadvantage of equity financing?",
  options: ["loss of control", "fixed interest payments", "short repayment period", "high liquidity"],
  answer: "loss of control"
},
{
  question: "Debentures are:",
  options: ["long-term loans with fixed interest", "shares of ownership", "short-term credit", "internal funds"],
  answer: "long-term loans with fixed interest"
},
{
  question: "Working capital refers to:",
  options: ["funds used for day-to-day operations", "money for long-term assets", "total revenue", "net profit"],
  answer: "funds used for day-to-day operations"
},
{
  question: "A business with insufficient working capital may face:",
  options: ["liquidity problems", "high profits", "increased production", "strong expansion"],
  answer: "liquidity problems"
},
{
  question: "Fixed costs are costs that:",
  options: ["do not change with output", "increase with production", "decrease with sales", "depend on profit"],
  answer: "do not change with output"
},
{
  question: "Variable costs are costs that:",
  options: ["change with level of output", "remain constant", "are fixed monthly", "depend on assets"],
  answer: "change with level of output"
},
{
  question: "Break-even point is where:",
  options: ["total cost equals total revenue", "profit is maximum", "loss is highest", "sales are lowest"],
  answer: "total cost equals total revenue"
},
{
  question: "A firm making sales above break-even point will:",
  options: ["earn profit", "incur loss", "break even", "reduce revenue"],
  answer: "earn profit"
},
{
  question: "Which of the following increases profit?",
  options: ["reducing costs", "increasing expenses", "lowering prices only", "increasing losses"],
  answer: "reducing costs"
},
{
  question: "Budgeting in business helps to:",
  options: ["control and plan finances", "increase expenses", "eliminate profits", "reduce planning"],
  answer: "control and plan finances"
},
{
  question: "A budget is best described as:",
  options: ["a financial plan for a future period", "past financial record", "daily expense sheet", "profit statement"],
  answer: "a financial plan for a future period"
},
{
  question: "Which of the following is a limitation of budgeting?",
  options: ["based on estimates", "provides control", "improves planning", "guides decisions"],
  answer: "based on estimates"
},
{
  question: "Net profit is calculated as:",
  options: ["total revenue minus total expenses", "sales minus variable cost", "revenue minus fixed cost", "income minus assets"],
  answer: "total revenue minus total expenses"
},
{
  question: "Gross profit is:",
  options: ["sales minus cost of goods sold", "total revenue minus expenses", "income minus tax", "sales minus fixed cost"],
  answer: "sales minus cost of goods sold"
},
{
  question: "Which financial source does NOT require repayment?",
  options: ["equity shares", "bank loan", "debenture", "overdraft"],
  answer: "equity shares"
},
{
  question: "A business relying heavily on loans may face:",
  options: ["high interest burden", "low expenses", "increased control", "reduced risk"],
  answer: "high interest burden"
},

{
  question: "Marketing is best defined as:",
  options: ["process of identifying and satisfying customer needs profitably", "selling goods only", "advertising products", "distribution of goods only"],
  answer: "process of identifying and satisfying customer needs profitably"
},
{
  question: "Which element of marketing mix deals with how goods reach consumers?",
  options: ["place", "product", "price", "promotion"],
  answer: "place"
},
{
  question: "A company lowering its price to increase sales is adjusting:",
  options: ["price", "promotion", "place", "product"],
  answer: "price"
},
{
  question: "Product differentiation helps a business to:",
  options: ["stand out from competitors", "reduce production", "increase cost only", "eliminate marketing"],
  answer: "stand out from competitors"
},
{
  question: "Which of the following best explains promotion?",
  options: ["communicating product value to customers", "reducing prices", "manufacturing goods", "storing goods"],
  answer: "communicating product value to customers"
},
{
  question: "Demand refers to:",
  options: ["willingness and ability to buy", "desire only", "supply of goods", "production level"],
  answer: "willingness and ability to buy"
},
{
  question: "An increase in price generally leads to:",
  options: ["decrease in demand", "increase in demand", "no change", "unpredictable change"],
  answer: "decrease in demand"
},
{
  question: "Which factor can shift demand curve to the right?",
  options: ["increase in consumer income", "increase in price", "decrease in population", "reduction in advertising"],
  answer: "increase in consumer income"
},
{
  question: "Consumer behavior is influenced mainly by:",
  options: ["income, taste and preferences", "government laws only", "business location", "production cost"],
  answer: "income, taste and preferences"
},
{
  question: "Market research is conducted to:",
  options: ["understand customer needs", "increase production cost", "reduce profit", "limit sales"],
  answer: "understand customer needs"
},
{
  question: "Which method of market research collects primary data?",
  options: ["survey", "published reports", "government statistics", "books"],
  answer: "survey"
},
{
  question: "Branding helps to:",
  options: ["create product identity", "reduce cost", "increase production", "eliminate competition"],
  answer: "create product identity"
},
{
  question: "A strong brand leads to:",
  options: ["customer loyalty", "reduced demand", "higher cost only", "lower quality"],
  answer: "customer loyalty"
},
{
  question: "Which pricing strategy sets low prices to enter a competitive market?",
  options: ["penetration pricing", "skimming pricing", "premium pricing", "cost-plus pricing"],
  answer: "penetration pricing"
},
{
  question: "Price skimming involves:",
  options: ["charging high initial price then reducing", "setting low price always", "matching competitor price", "ignoring demand"],
  answer: "charging high initial price then reducing"
},
{
  question: "Advertising is a form of:",
  options: ["promotion", "production", "distribution", "pricing"],
  answer: "promotion"
},
{
  question: "Which factor affects supply directly?",
  options: ["cost of production", "consumer income", "taste", "advertising"],
  answer: "cost of production"
},
{
  question: "An increase in production cost will:",
  options: ["reduce supply", "increase supply", "not affect supply", "increase demand"],
  answer: "reduce supply"
},
{
  question: "Which of the following best explains customer satisfaction?",
  options: ["meeting or exceeding expectations", "low pricing only", "high production", "large inventory"],
  answer: "meeting or exceeding expectations"
},
{
  question: "A business losing customers despite high sales promotion likely has:",
  options: ["poor product quality", "high demand", "effective pricing", "strong branding"],
  answer: "poor product quality"
},

{
  question: "Human resource management is mainly concerned with:",
  options: ["managing people effectively in an organization", "managing machines only", "producing goods", "controlling finance"],
  answer: "managing people effectively in an organization"
},
{
  question: "Recruitment is the process of:",
  options: ["attracting suitable candidates for a job", "selecting candidates only", "training employees", "paying wages"],
  answer: "attracting suitable candidates for a job"
},
{
  question: "Selection involves:",
  options: ["choosing the most suitable candidate", "advertising vacancies", "training workers", "promoting employees"],
  answer: "choosing the most suitable candidate"
},
{
  question: "Internal recruitment refers to:",
  options: ["hiring from within the organization", "hiring new workers", "outsourcing jobs", "contracting labour"],
  answer: "hiring from within the organization"
},
{
  question: "Which of the following is an advantage of internal recruitment?",
  options: ["motivates existing employees", "brings new ideas always", "reduces training cost completely", "increases labour turnover"],
  answer: "motivates existing employees"
},
{
  question: "External recruitment may lead to:",
  options: ["new skills and ideas", "employee dissatisfaction only", "reduced diversity", "low competition"],
  answer: "new skills and ideas"
},
{
  question: "Training is important because it:",
  options: ["improves employee performance", "reduces productivity", "increases errors", "eliminates supervision"],
  answer: "improves employee performance"
},
{
  question: "On-the-job training occurs when:",
  options: ["employees learn while working", "training is done outside company", "employees attend lectures only", "training is theoretical"],
  answer: "employees learn while working"
},
{
  question: "Which of the following is off-the-job training?",
  options: ["seminars and workshops", "learning during work", "apprenticeship only", "supervision training"],
  answer: "seminars and workshops"
},
{
  question: "Induction training is meant to:",
  options: ["introduce new employees to the organization", "promote workers", "increase wages", "reduce turnover"],
  answer: "introduce new employees to the organization"
},
{
  question: "Labour turnover refers to:",
  options: ["rate at which employees leave and join", "employee productivity", "training level", "wage structure"],
  answer: "rate at which employees leave and join"
},
{
  question: "High labour turnover may indicate:",
  options: ["poor working conditions", "high employee satisfaction", "good leadership", "strong motivation"],
  answer: "poor working conditions"
},
{
  question: "Which wage system pays workers based on output?",
  options: ["piece rate system", "time rate system", "salary system", "bonus system"],
  answer: "piece rate system"
},
{
  question: "Time rate system pays employees based on:",
  options: ["hours worked", "output produced", "sales achieved", "profit earned"],
  answer: "hours worked"
},
{
  question: "Which incentive encourages higher productivity?",
  options: ["bonus payment", "strict supervision", "reduced wages", "long working hours"],
  answer: "bonus payment"
},
{
  question: "Employee motivation is improved by:",
  options: ["recognition and rewards", "punishment", "job insecurity", "poor conditions"],
  answer: "recognition and rewards"
},
{
  question: "Which of the following is a non-financial incentive?",
  options: ["job satisfaction", "salary increase", "bonus", "commission"],
  answer: "job satisfaction"
},
{
  question: "A business experiencing low productivity should:",
  options: ["improve training and motivation", "reduce wages", "increase workload only", "ignore employees"],
  answer: "improve training and motivation"
},
{
  question: "Performance appraisal is used to:",
  options: ["evaluate employee performance", "hire employees", "train workers", "set wages"],
  answer: "evaluate employee performance"
},
{
  question: "Which of the following improves employee retention?",
  options: ["good working conditions", "low wages", "lack of promotion", "job insecurity"],
  answer: "good working conditions"
},

{
  question: "The business environment refers to:",
  options: ["all internal and external factors affecting business", "internal factors only", "external factors only", "financial factors only"],
  answer: "all internal and external factors affecting business"
},
{
  question: "Internal environment includes:",
  options: ["organizational structure and employees", "government policies", "economic conditions", "technological changes"],
  answer: "organizational structure and employees"
},
{
  question: "Which of the following is an external factor affecting business?",
  options: ["government regulations", "management style", "employee skills", "organizational culture"],
  answer: "government regulations"
},
{
  question: "Inflation affects business by:",
  options: ["increasing cost of production", "reducing demand always", "eliminating profit", "stabilizing prices"],
  answer: "increasing cost of production"
},
{
  question: "High interest rates may lead to:",
  options: ["reduced borrowing", "increased investment", "lower costs", "higher profits"],
  answer: "reduced borrowing"
},
{
  question: "Government taxation affects business by:",
  options: ["reducing profit margins", "increasing demand", "improving productivity", "reducing competition"],
  answer: "reducing profit margins"
},
{
  question: "Which policy encourages business growth?",
  options: ["tax incentives", "high taxation", "strict regulations", "trade restrictions"],
  answer: "tax incentives"
},
{
  question: "Technological advancement helps businesses to:",
  options: ["increase efficiency", "reduce productivity", "limit communication", "increase cost only"],
  answer: "increase efficiency"
},
{
  question: "Which of the following best explains globalization?",
  options: ["integration of world markets", "local trade only", "government ownership", "domestic production"],
  answer: "integration of world markets"
},
{
  question: "Globalization increases competition by:",
  options: ["allowing foreign firms to enter markets", "reducing trade", "eliminating exports", "limiting business growth"],
  answer: "allowing foreign firms to enter markets"
},
{
  question: "A stable political environment encourages:",
  options: ["business investment", "business failure", "reduced production", "higher risk"],
  answer: "business investment"
},
{
  question: "Which of the following is a social factor affecting business?",
  options: ["consumer lifestyle changes", "interest rates", "tax laws", "inflation"],
  answer: "consumer lifestyle changes"
},
{
  question: "Environmental regulations affect business by:",
  options: ["increasing compliance costs", "reducing production only", "eliminating profit", "reducing demand"],
  answer: "increasing compliance costs"
},
{
  question: "Which factor affects demand directly?",
  options: ["consumer income", "production cost", "government policy", "technology"],
  answer: "consumer income"
},
{
  question: "Economic recession leads to:",
  options: ["reduced consumer spending", "increased demand", "higher profits", "expansion of business"],
  answer: "reduced consumer spending"
},
{
  question: "Which of the following is a legal factor affecting business?",
  options: ["labour laws", "consumer taste", "technology", "income levels"],
  answer: "labour laws"
},
{
  question: "Exchange rate fluctuations affect businesses involved in:",
  options: ["international trade", "local sales", "domestic production", "internal management"],
  answer: "international trade"
},
{
  question: "Which of the following best explains economic environment?",
  options: ["conditions affecting production and consumption", "internal management structure", "employee behavior", "company policy"],
  answer: "conditions affecting production and consumption"
},
{
  question: "A business adapting to environmental changes demonstrates:",
  options: ["flexibility", "rigidity", "inefficiency", "poor planning"],
  answer: "flexibility"
},
{
  question: "Which of the following can cause sudden business failure?",
  options: ["unexpected external shocks", "good management", "high demand", "efficient planning"],
  answer: "unexpected external shocks"
},

{
  question: "International trade involves:",
  options: ["exchange of goods and services between countries", "local buying and selling", "internal company transactions", "government spending only"],
  answer: "exchange of goods and services between countries"
},
{
  question: "Exports refer to:",
  options: ["goods sold to other countries", "goods bought from abroad", "local goods only", "services within country"],
  answer: "goods sold to other countries"
},
{
  question: "Imports refer to:",
  options: ["goods bought from other countries", "goods sold locally", "goods produced locally", "services exported"],
  answer: "goods bought from other countries"
},
{
  question: "Balance of trade is the difference between:",
  options: ["exports and imports", "revenue and cost", "assets and liabilities", "profit and loss"],
  answer: "exports and imports"
},
{
  question: "A favorable balance of trade occurs when:",
  options: ["exports exceed imports", "imports exceed exports", "exports equal imports", "trade is restricted"],
  answer: "exports exceed imports"
},
{
  question: "A country with high imports and low exports has:",
  options: ["unfavorable balance of trade", "favorable balance", "stable economy", "no trade deficit"],
  answer: "unfavorable balance of trade"
},
{
  question: "Tariffs are:",
  options: ["taxes on imports", "subsidies on exports", "government spending", "currency exchange"],
  answer: "taxes on imports"
},
{
  question: "The main purpose of tariffs is to:",
  options: ["protect local industries", "increase imports", "reduce exports", "increase competition"],
  answer: "protect local industries"
},
{
  question: "Quotas restrict:",
  options: ["quantity of goods imported", "price of goods", "quality of goods", "production level"],
  answer: "quantity of goods imported"
},
{
  question: "Which of the following is a benefit of international trade?",
  options: ["access to wider markets", "reduced competition", "limited choice", "higher costs always"],
  answer: "access to wider markets"
},
{
  question: "International trade allows countries to:",
  options: ["specialize in production", "produce everything locally", "avoid competition", "reduce efficiency"],
  answer: "specialize in production"
},
{
  question: "Exchange rate refers to:",
  options: ["value of one currency in terms of another", "interest rate of banks", "price of goods", "tax rate"],
  answer: "value of one currency in terms of another"
},
{
  question: "A depreciation of currency makes exports:",
  options: ["cheaper and more competitive", "more expensive", "unchanged", "less attractive"],
  answer: "cheaper and more competitive"
},
{
  question: "A strong currency may lead to:",
  options: ["increased imports", "increased exports", "reduced imports", "trade surplus"],
  answer: "increased imports"
},
{
  question: "Which of the following is a barrier to international trade?",
  options: ["tariffs and quotas", "free trade agreements", "global markets", "technology"],
  answer: "tariffs and quotas"
},
{
  question: "Free trade encourages:",
  options: ["removal of trade barriers", "increase in tariffs", "restriction of imports", "limited competition"],
  answer: "removal of trade barriers"
},
{
  question: "Dumping occurs when:",
  options: ["goods are sold below cost in foreign markets", "goods are exported at high prices", "goods are imported legally", "goods are taxed"],
  answer: "goods are sold below cost in foreign markets"
},
{
  question: "Which organization promotes global trade?",
  options: ["World Trade Organization", "Central Bank", "Local Council", "Private Firms"],
  answer: "World Trade Organization"
},
{
  question: "Trade deficit occurs when:",
  options: ["imports exceed exports", "exports exceed imports", "imports equal exports", "trade is balanced"],
  answer: "imports exceed exports"
},
{
  question: "Which of the following best explains comparative advantage?",
  options: ["ability to produce goods at lower opportunity cost", "ability to produce more goods", "higher production cost", "low quality production"],
  answer: "ability to produce goods at lower opportunity cost"
},

{
  question: "An entrepreneur is best defined as a person who:",
  options: ["identifies opportunities and takes risks to create a business", "manages an existing company only", "works for salary", "controls government policies"],
  answer: "identifies opportunities and takes risks to create a business"
},
{
  question: "Which of the following is a key characteristic of successful entrepreneurs?",
  options: ["risk-taking ability", "fear of failure", "dependence on others", "lack of innovation"],
  answer: "risk-taking ability"
},
{
  question: "Innovation in business refers to:",
  options: ["introducing new ideas or methods", "copying competitors", "reducing production", "increasing cost"],
  answer: "introducing new ideas or methods"
},
{
  question: "A business opportunity arises when:",
  options: ["there is a gap in the market", "competition is high", "costs are high", "profits are low"],
  answer: "there is a gap in the market"
},
{
  question: "Which of the following is the main aim of entrepreneurship?",
  options: ["creating value and profit", "reducing employment", "increasing cost", "avoiding risk"],
  answer: "creating value and profit"
},
{
  question: "Entrepreneurial risk refers to:",
  options: ["uncertainty in business outcomes", "guaranteed profit", "fixed cost", "stable market"],
  answer: "uncertainty in business outcomes"
},
{
  question: "Which of the following is a financial risk?",
  options: ["loss of capital", "poor leadership", "low motivation", "bad communication"],
  answer: "loss of capital"
},
{
  question: "A feasibility study is conducted to:",
  options: ["assess viability of a business idea", "increase production", "hire employees", "reduce marketing"],
  answer: "assess viability of a business idea"
},
{
  question: "Business plan is important because it:",
  options: ["guides business operations", "reduces profit", "increases risk", "limits planning"],
  answer: "guides business operations"
},
{
  question: "Which of the following is included in a business plan?",
  options: ["marketing strategy", "personal hobbies", "family details", "social activities"],
  answer: "marketing strategy"
},
{
  question: "A start-up business requires capital mainly for:",
  options: ["initial operations and setup", "government policy", "employee training only", "social events"],
  answer: "initial operations and setup"
},
{
  question: "Which factor contributes most to business failure?",
  options: ["poor management", "high demand", "strong planning", "good leadership"],
  answer: "poor management"
},
{
  question: "Entrepreneurs contribute to the economy by:",
  options: ["creating employment", "reducing output", "limiting innovation", "increasing imports"],
  answer: "creating employment"
},
{
  question: "Which of the following is a non-financial motivation for entrepreneurs?",
  options: ["self-fulfillment", "salary increase", "bonus", "commission"],
  answer: "self-fulfillment"
},
{
  question: "A business that introduces a new product to dominate the market demonstrates:",
  options: ["innovation", "imitation", "risk avoidance", "inefficiency"],
  answer: "innovation"
},
{
  question: "Which of the following is a challenge faced by entrepreneurs?",
  options: ["limited access to finance", "high profit always", "low competition", "strong market demand"],
  answer: "limited access to finance"
},
{
  question: "Entrepreneurs improve productivity by:",
  options: ["introducing efficient methods", "reducing technology", "limiting workers", "increasing waste"],
  answer: "introducing efficient methods"
},
{
  question: "Which of the following best explains opportunity cost in entrepreneurship?",
  options: ["value of next best alternative forgone", "total business cost", "fixed cost", "profit margin"],
  answer: "value of next best alternative forgone"
},
{
  question: "Which of the following encourages entrepreneurship?",
  options: ["access to finance", "high taxes", "strict regulations", "low demand"],
  answer: "access to finance"
},
{
  question: "A successful entrepreneur must be able to:",
  options: ["make effective decisions under uncertainty", "avoid all risks", "depend on others", "ignore market changes"],
  answer: "make effective decisions under uncertainty"
},

{
  question: "A firm increases advertising but experiences declining sales. The most likely cause is:",
  options: ["poor product quality", "low promotion effort", "high demand", "effective pricing"],
  answer: "poor product quality"
},
{
  question: "A business expands using borrowed funds but struggles to repay. This indicates:",
  options: ["poor financial management", "high profitability", "effective planning", "strong liquidity"],
  answer: "poor financial management"
},
{
  question: "Which of the following best explains economies of scale?",
  options: ["reduction in average cost as output increases", "increase in total cost", "reduction in production", "increase in fixed cost"],
  answer: "reduction in average cost as output increases"
},
{
  question: "A company producing large quantities but making losses likely has:",
  options: ["high costs exceeding revenue", "low demand", "efficient production", "strong marketing"],
  answer: "high costs exceeding revenue"
},
{
  question: "Which of the following links HR and productivity directly?",
  options: ["employee motivation", "government regulation", "tax policy", "exchange rate"],
  answer: "employee motivation"
},
{
  question: "A manager ignores employee feedback, resulting in low morale. This reflects poor:",
  options: ["communication", "production", "finance", "marketing"],
  answer: "communication"
},
{
  question: "A contract becomes voidable when:",
  options: ["one party is misled", "all conditions are met", "consideration exists", "both parties agree"],
  answer: "one party is misled"
},
{
  question: "Which of the following best explains working capital management?",
  options: ["managing short-term assets and liabilities", "long-term investment planning", "profit calculation only", "tax planning"],
  answer: "managing short-term assets and liabilities"
},
{
  question: "A firm lowers prices but profits decline. The likely reason is:",
  options: ["costs are too high", "demand increased", "market expanded", "competition reduced"],
  answer: "costs are too high"
},
{
  question: "Which of the following is a benefit of decentralization?",
  options: ["faster decision-making", "reduced responsibility", "central control", "less flexibility"],
  answer: "faster decision-making"
},
{
  question: "A business fails due to inability to adapt to technology. This reflects:",
  options: ["poor environmental analysis", "strong planning", "effective leadership", "high innovation"],
  answer: "poor environmental analysis"
},
{
  question: "Which of the following affects both demand and supply?",
  options: ["government policy", "product design", "employee training", "organizational structure"],
  answer: "government policy"
},
{
  question: "A business focusing only on profit may neglect:",
  options: ["social responsibility", "marketing strategy", "production efficiency", "financial planning"],
  answer: "social responsibility"
},
{
  question: "A fall in exchange rate will likely:",
  options: ["increase exports", "increase imports", "reduce exports", "have no effect"],
  answer: "increase exports"
},
{
  question: "Which of the following best explains leadership effectiveness?",
  options: ["ability to influence and motivate employees", "authority only", "control of resources", "ownership of business"],
  answer: "ability to influence and motivate employees"
},
{
  question: "A business using ICT to reduce costs demonstrates:",
  options: ["efficiency improvement", "increased risk", "poor planning", "low productivity"],
  answer: "efficiency improvement"
},
{
  question: "Which of the following is a limitation of international trade?",
  options: ["exposure to global competition", "access to markets", "specialization", "increased output"],
  answer: "exposure to global competition"
},
{
  question: "A motivated workforce leads to:",
  options: ["higher productivity", "lower efficiency", "reduced output", "increased turnover"],
  answer: "higher productivity"
},
{
  question: "Which of the following best explains strategic planning?",
  options: ["long-term decision-making", "daily operations", "routine tasks", "short-term budgeting"],
  answer: "long-term decision-making"
},
{
  question: "A business with poor control systems is likely to:",
  options: ["deviate from planned objectives", "achieve targets easily", "increase efficiency", "reduce errors"],
  answer: "deviate from planned objectives"
},

{
  question: "A firm’s total cost is GH₵10,000 and total revenue is GH₵12,500. Its profit is:",
  options: ["GH₵2,500", "GH₵22,500", "GH₵10,000", "GH₵2,000"],
  answer: "GH₵2,500"
},
{
  question: "A business sells 500 units at GH₵20 each. Variable cost per unit is GH₵12. Total contribution is:",
  options: ["GH₵4,000", "GH₵10,000", "GH₵6,000", "GH₵8,000"],
  answer: "GH₵4,000"
},
{
  question: "Break-even point occurs when:",
  options: ["total revenue equals total cost", "profit is maximum", "sales are highest", "fixed cost is zero"],
  answer: "total revenue equals total cost"
},
{
  question: "A company’s fixed cost is GH₵5,000 and contribution per unit is GH₵10. Break-even output is:",
  options: ["500 units", "50 units", "5,000 units", "100 units"],
  answer: "500 units"
},
{
  question: "A business increases sales but profit falls. The most likely reason is:",
  options: ["increase in costs", "increase in demand", "better marketing", "lower competition"],
  answer: "increase in costs"
},
{
  question: "Government imposing high taxes on firms may lead to:",
  options: ["reduced business expansion", "increased production", "higher profits", "lower costs"],
  answer: "reduced business expansion"
},
{
  question: "Subsidies from government help businesses by:",
  options: ["reducing production costs", "increasing taxes", "reducing demand", "increasing losses"],
  answer: "reducing production costs"
},
{
  question: "A business polluting the environment is failing in its:",
  options: ["social responsibility", "economic objective", "financial planning", "production efficiency"],
  answer: "social responsibility"
},
{
  question: "Ethical business practices involve:",
  options: ["fair and honest dealings", "profit maximization only", "cost reduction only", "market domination"],
  answer: "fair and honest dealings"
},
{
  question: "A firm refusing to improve worker conditions may face:",
  options: ["low productivity", "high profit", "strong loyalty", "increased efficiency"],
  answer: "low productivity"
},
{
  question: "A company reduces price to attract customers but loses profit. This suggests:",
  options: ["poor pricing strategy", "effective marketing", "high demand", "good planning"],
  answer: "poor pricing strategy"
},
{
  question: "A firm diversifying its products is trying to:",
  options: ["reduce business risk", "increase costs", "reduce sales", "limit growth"],
  answer: "reduce business risk"
},
{
  question: "A business facing strong competition should:",
  options: ["differentiate its products", "reduce quality", "ignore market", "increase costs"],
  answer: "differentiate its products"
},
{
  question: "A company with poor leadership and planning is likely to:",
  options: ["fail in operations", "increase profit", "improve productivity", "reduce risk"],
  answer: "fail in operations"
},
{
  question: "Which of the following improves long-term business survival?",
  options: ["strategic planning", "short-term decisions", "random decisions", "high risk only"],
  answer: "strategic planning"
},
{
  question: "A firm operating below break-even point will:",
  options: ["incur losses", "make profit", "break even", "increase revenue"],
  answer: "incur losses"
},
{
  question: "Government regulation can benefit consumers by:",
  options: ["ensuring quality standards", "increasing prices", "reducing supply", "limiting production"],
  answer: "ensuring quality standards"
},
{
  question: "A business failing to adapt to external changes is experiencing:",
  options: ["poor environmental analysis", "strong planning", "good management", "effective strategy"],
  answer: "poor environmental analysis"
},
{
  question: "Corporate social responsibility improves business by:",
  options: ["enhancing public image", "reducing profit always", "increasing cost only", "limiting growth"],
  answer: "enhancing public image"
},
{
  question: "A company investing in employee training is likely to:",
  options: ["increase productivity", "reduce efficiency", "increase errors", "reduce output"],
  answer: "increase productivity"
},

{
  question: "A company increases production but total profit declines. The most likely cause is:",
  options: ["rising production costs", "higher demand", "improved efficiency", "better pricing"],
  answer: "rising production costs"
},
{
  question: "A firm relies heavily on one product and faces sudden market decline. This shows lack of:",
  options: ["diversification", "planning", "motivation", "communication"],
  answer: "diversification"
},
{
  question: "A manager delegates tasks but employees perform poorly. The main issue is likely:",
  options: ["lack of supervision and training", "too much planning", "high motivation", "strong leadership"],
  answer: "lack of supervision and training"
},
{
  question: "A business experiences high employee turnover. The most probable cause is:",
  options: ["poor working conditions", "high wages", "strong leadership", "good motivation"],
  answer: "poor working conditions"
},
{
  question: "A firm lowers prices but competitors follow immediately. The result is:",
  options: ["reduced profit margins", "higher monopoly power", "increased differentiation", "lower competition"],
  answer: "reduced profit margins"
},
{
  question: "A business using outdated technology will likely:",
  options: ["lose competitive advantage", "increase productivity", "reduce costs", "improve efficiency"],
  answer: "lose competitive advantage"
},
{
  question: "A company expands internationally but fails due to cultural differences. This reflects poor:",
  options: ["market research", "production planning", "financial control", "human resource management"],
  answer: "market research"
},
{
  question: "A firm fails despite high sales due to poor cash flow. This indicates:",
  options: ["liquidity problems", "low demand", "high production", "strong marketing"],
  answer: "liquidity problems"
},
{
  question: "A business ignoring environmental laws risks:",
  options: ["legal penalties", "higher profits", "market expansion", "customer loyalty"],
  answer: "legal penalties"
},
{
  question: "Which of the following ensures effective management control?",
  options: ["continuous monitoring and corrective action", "strict punishment only", "centralized authority", "reduced communication"],
  answer: "continuous monitoring and corrective action"
},
{
  question: "A firm with strong leadership but poor planning is likely to:",
  options: ["fail to achieve long-term goals", "increase profits", "improve coordination", "reduce risk"],
  answer: "fail to achieve long-term goals"
},
{
  question: "A company invests heavily in marketing but ignores production quality. The likely outcome is:",
  options: ["customer dissatisfaction", "increased loyalty", "higher demand", "strong brand"],
  answer: "customer dissatisfaction"
},
{
  question: "Which of the following best explains opportunity cost in business decisions?",
  options: ["value of next best alternative forgone", "total cost of production", "profit earned", "fixed cost"],
  answer: "value of next best alternative forgone"
},
{
  question: "A business fails to adapt to changing consumer preferences. This shows weakness in:",
  options: ["marketing strategy", "financial planning", "legal compliance", "production capacity"],
  answer: "marketing strategy"
},
{
  question: "A firm increases wages but productivity does not improve. The likely reason is:",
  options: ["lack of motivation factors beyond pay", "low wages", "poor planning", "strong leadership"],
  answer: "lack of motivation factors beyond pay"
},
{
  question: "A company facing high competition should focus on:",
  options: ["innovation and differentiation", "cost increase", "reduced quality", "limited production"],
  answer: "innovation and differentiation"
},
{
  question: "A business that fails to control costs effectively will:",
  options: ["reduce profitability", "increase revenue", "improve efficiency", "expand market share"],
  answer: "reduce profitability"
},
{
  question: "A manager making decisions without consulting subordinates is using:",
  options: ["autocratic leadership", "democratic leadership", "laissez-faire leadership", "participative leadership"],
  answer: "autocratic leadership"
},
{
  question: "A business improves its public image by engaging in:",
  options: ["corporate social responsibility", "cost cutting only", "price increase", "reduced wages"],
  answer: "corporate social responsibility"
},
{
  question: "A firm operating efficiently but failing financially likely has:",
  options: ["poor financial management", "low production", "weak marketing", "high demand"],
  answer: "poor financial management"
},

{
  question: "A manufacturing firm experiences increasing sales but declining profits over three years. Investigation reveals rising production costs and inefficient processes. The most appropriate management action is to:",
  options: ["improve operational efficiency and cost control", "increase selling price immediately", "reduce marketing efforts", "expand production further"],
  answer: "improve operational efficiency and cost control"
},
{
  question: "A company introduces a new product without conducting market research and faces low demand. This failure is mainly due to poor:",
  options: ["planning and market analysis", "financial management", "production process", "employee training"],
  answer: "planning and market analysis"
},
{
  question: "An organization suffers from slow decision-making because all decisions are made by top management. The best solution is to:",
  options: ["decentralize decision-making", "increase supervision", "reduce employees", "centralize further"],
  answer: "decentralize decision-making"
},
{
  question: "A firm invests heavily in advertising but customer complaints about product quality increase. The most likely outcome is:",
  options: ["decline in customer loyalty", "increase in market share", "higher profit margins", "reduced competition"],
  answer: "decline in customer loyalty"
},
{
  question: "A business experiences frequent employee turnover despite offering competitive salaries. This suggests a problem with:",
  options: ["non-financial motivation factors", "financial management", "production efficiency", "marketing strategy"],
  answer: "non-financial motivation factors"
},
{
  question: "A company expands into international markets but fails due to lack of understanding of local culture. This indicates failure in:",
  options: ["environmental analysis", "financial planning", "production management", "human resource training"],
  answer: "environmental analysis"
},
{
  question: "A firm uses outdated technology while competitors adopt advanced systems. The likely long-term effect is:",
  options: ["loss of competitive advantage", "increase in profit", "higher demand", "reduced costs"],
  answer: "loss of competitive advantage"
},
{
  question: "A company faces cash flow problems despite making profits. This indicates poor:",
  options: ["working capital management", "marketing strategy", "production planning", "employee motivation"],
  answer: "working capital management"
},
{
  question: "A business increases output but fails to meet customer expectations. The most likely cause is:",
  options: ["lack of quality control", "low production", "high marketing effort", "strong competition"],
  answer: "lack of quality control"
},
{
  question: "A manager adopts a leadership style that involves employees in decision-making. This is likely to:",
  options: ["increase employee commitment", "reduce productivity", "slow communication only", "increase conflict always"],
  answer: "increase employee commitment"
},
{
  question: "A firm reduces price to gain market share but competitors match the price reduction. The long-term effect is:",
  options: ["reduced industry profitability", "market dominance", "increased profit", "reduced competition"],
  answer: "reduced industry profitability"
},
{
  question: "A business ignores government regulations to reduce costs. This may lead to:",
  options: ["legal sanctions and reputational damage", "increased profit sustainably", "higher market share", "customer loyalty"],
  answer: "legal sanctions and reputational damage"
},
{
  question: "A company relies on one supplier and faces disruption when the supplier fails. This shows lack of:",
  options: ["risk management strategy", "marketing planning", "financial control", "employee training"],
  answer: "risk management strategy"
},
{
  question: "A firm introduces automation, reducing labor costs but causing employee dissatisfaction. Management should:",
  options: ["balance efficiency with employee welfare", "ignore employee concerns", "increase production only", "reduce automation"],
  answer: "balance efficiency with employee welfare"
},
{
  question: "A business fails to achieve its goals due to lack of coordination among departments. This reflects poor:",
  options: ["organizing function", "planning function", "marketing strategy", "financial management"],
  answer: "organizing function"
},
{
  question: "A company improves customer service and product quality, resulting in increased loyalty. This demonstrates:",
  options: ["effective marketing strategy", "poor planning", "weak leadership", "high production cost"],
  answer: "effective marketing strategy"
},
{
  question: "A firm increases wages but productivity remains unchanged. The best explanation is:",
  options: ["lack of intrinsic motivation", "low wages", "strong leadership", "good communication"],
  answer: "lack of intrinsic motivation"
},
{
  question: "A business expands rapidly without proper planning and collapses. This highlights the importance of:",
  options: ["strategic planning", "production only", "marketing only", "employee training only"],
  answer: "strategic planning"
},
{
  question: "A company improves its brand image through environmental protection initiatives. This is an example of:",
  options: ["corporate social responsibility", "profit maximization", "cost reduction", "market expansion"],
  answer: "corporate social responsibility"
},
{
  question: "A firm diversifies its product range to reduce dependency on one market. This strategy helps to:",
  options: ["minimize business risk", "increase cost only", "reduce efficiency", "limit growth"],
  answer: "minimize business risk"
}

];

export default businessManagementQuestions;
